import getResolution from './getResolution';

const FULL_HD = 1920;

export const getRelativePixel = pixels => {
  if (!pixels) {
    return 0;
  }

  const { width } = getResolution();
  const fullHDContext = FULL_HD * 0.01;
  const currentContext = width * 0.01;
  const _vw = pixels / fullHDContext;

  return Math.round(_vw * currentContext);
};
